export const environment = {
  production: true,
  // apiUrl: "https://umyonba.site/api_umyocards/public/api/"
  apiUrl: "https://lieutenantsacademydfw.org/api_umyocards/public/api/"
};


